/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-use-before-define */
/* eslint-disable no-debugger */
/* eslint-disable radix */
// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
// COMPONENTS
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Box from '@mui/material/Box';
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
// ICONS
import { HiOutlineTrash } from 'react-icons/hi';
// CUSTOM COMPONENTS
import CustomBlock from '../../../../components/CustomBlock';
import Section from '../../../../components/Section';
import ContentBlock from '../../../../components/ContentBlock';
import ContentHeader from '../../../../components/ContentHeader';
import SelectBlock from '../../../../components/SelectBlock';
import Button from '../../../../components/Button';
import Overlay from '../../../../components/Overlay';
import FormBlock from '../../../../components/FormBlock';
import InputBlock from '../../../../components/InputBlock';
import ModalBlock from '../../../../components/ModalBlock';
import ConnectionCreateForm from './ConnectionCreateForm';
// REDUX
import * as alert from '../../../../redux/alertToastRedux';
import * as confirmModal from '../../../../redux/confirmModalRedux';
// SERVICES AND HELPERS
import * as helper from '../../../../helpers/helper';
import * as licensorService from '../../../../services/management/licensorService';
import * as connectionTypeService from '../../../../services/management/connectionTypeService';
import * as connectionService from '../../../../services/management/connectionService';

const LicensorManagementPage = (props) => {
  const { auth, showConfirmModal, showAlert, hideConfirmModal } = props;
  const { licensorId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [isConnectionTypeModalOpen, setIsConnectionTypeModalOpen] = useState(false);
  const [sizeFilter, setSizeFilter] = useState({ label: 'All', value: 'All' });
  const [activeConnectionTypeName, setActiveConnectionTypeName] = useState('');
  const apiRef = useGridApiRef();
  const [sizeOptions, setSizeOptions] = useState([]);
  const [tabKey, setTabKey] = useState(-1);
  const [connections, setConnections] = useState([]);
  const initialConnectionTypeModel = {
    id: 0,
    licensorId,
    name: ''
  };
  const [connectionType, setConnectionType] = useState(initialConnectionTypeModel);
  const [licensor, setLicensor] = useState({
    name: '',
    connectionTypes: [],
  });
  const [isConnectionModalVisible, setIsConnectionModalVisible] = useState(false);
  const [filteredSource, setFilteredSource] = useState(connections);

  useEffect(() => {
    getLicensor();
  }, []);

  useEffect(() => {
    setSizeFilter({ label: 'All', value: 'All' });
    setSizeOptions([
      { label: 'All', value: 'All' },
      ...(_.uniqBy(connections, 'size')
        .map((row) => (helper.setToOptionModel(row.size, row.size))))
    ]);
  }, [connections]);

  useEffect(() => {
    if (tabKey > -1 && licensor.connectionTypes.length > 0) {
      const activeConnectionType = licensor.connectionTypes.find((x) => x.id === parseInt(tabKey));

      if (activeConnectionType) {
        setActiveConnectionTypeName(activeConnectionType.name);
      }
      fetchConnections();
    }
  }, [tabKey]);

  useEffect(() => {
    if (sizeFilter.value === 'All') {
      setFilteredSource(connections);
    } else {
      setFilteredSource(connections.filter((x) => x.size === sizeFilter.value));
    }
  }, [sizeFilter, connections]);

  const columns = [
    {
      field: 'action',
      headerName: 'Action',
      sortable: false,
      width: 65,
      hide: auth.accessLevel <= 40,
      headerClassName: 'primary--bg white--clr',
      renderCell: (params) => (
        <CustomBlock className="content-container--actions flex-center pl-0 mt-0">
          <Button
            size="icon"
            className="danger--bg ml-0"
            iconLeft={<HiOutlineTrash className="white--clr" size={20} />}
            onClick={() => {
              showConfirmModal({
                title: 'Delete Connection',
                text: 'Are you sure you want to delete this connection?',
                rightBtnText: 'Confirm',
                btnAction: () => {
                  deleteConnection(params.id);
                }
              });
            }}
          />
        </CustomBlock>
      )
    },
    {
      field: 'group',
      headerName: 'MTR Groups',
      flex: 1,
      cellClassName: 'primary--bg white--clr',
      headerClassName: 'primary--bg white--clr',
    },
    {
      field: 'size',
      headerName: 'Size',
      flex: 1,
      headerClassName: 'primary--bg white--clr',
      editable: auth.accessLevel > 40
    },
    {
      field: 'weight',
      headerName: 'WGT',
      flex: 1,
      headerClassName: 'primary--bg white--clr',
      editable: auth.accessLevel > 40
    },
    {
      field: 'qty1',
      headerName: 'QTY 1',
      flex: 1,
      headerClassName: 'primary--bg white--clr',
      editable: auth.accessLevel > 40,
      type: 'number'
    },
    {
      field: 'qty2',
      headerName: 'QTY 2',
      flex: 1,
      headerClassName: 'primary--bg white--clr',
      editable: auth.accessLevel > 40,
      type: 'number',
      hide: licensor.isDifferent
    },
    {
      field: 'qty3to5',
      headerName: 'QTY 3-5',
      flex: 1,
      headerClassName: 'primary--bg white--clr',
      editable: auth.accessLevel > 40,
      type: 'number',
      hide: licensor.isDifferent
    },
    {
      field: 'qty6to10',
      headerName: 'QTY 6-10',
      flex: 1,
      headerClassName: 'primary--bg white--clr',
      editable: auth.accessLevel > 40,
      type: 'number',
      hide: licensor.isDifferent
    },
    {
      field: 'qty11to15',
      headerName: 'QTY 11-15',
      flex: 1,
      headerClassName: 'primary--bg white--clr',
      editable: auth.accessLevel > 40,
      type: 'number',
      hide: licensor.isDifferent
    },
    {
      field: 'qty16to20',
      headerName: 'QTY 16-20',
      flex: 1,
      headerClassName: 'primary--bg white--clr',
      editable: auth.accessLevel > 40,
      type: 'number',
      hide: licensor.isDifferent
    },
    {
      field: 'qty21to30',
      headerName: 'QTY 21-30',
      flex: 1,
      headerClassName: 'primary--bg white--clr',
      editable: auth.accessLevel > 40,
      type: 'number',
      hide: licensor.isDifferent
    },
    {
      field: 'qty31to50',
      headerName: 'QTY 31-50',
      flex: 1,
      headerClassName: 'primary--bg white--clr',
      editable: auth.accessLevel > 40,
      type: 'number',
      hide: licensor.isDifferent
    },
    {
      field: 'qty51to100',
      headerName: 'QTY 51-100',
      flex: 1,
      headerClassName: 'primary--bg white--clr',
      editable: auth.accessLevel > 40,
      type: 'number',
      hide: licensor.isDifferent
    },
    {
      field: 'qty2to4',
      headerName: 'QTY 2-4',
      flex: 1,
      headerClassName: 'primary--bg white--clr',
      editable: auth.accessLevel > 40,
      type: 'number',
      hide: !licensor.isDifferent
    },
    {
      field: 'qty5to9',
      headerName: 'QTY 5-9',
      flex: 1,
      headerClassName: 'primary--bg white--clr',
      editable: auth.accessLevel > 40,
      type: 'number',
      hide: !licensor.isDifferent
    },
    {
      field: 'qty10to24',
      headerName: 'QTY 10-24',
      flex: 1,
      headerClassName: 'primary--bg white--clr',
      editable: auth.accessLevel > 40,
      type: 'number',
      hide: !licensor.isDifferent
    },
    {
      field: 'qty25to100',
      headerName: 'QTY 25-39',
      flex: 1,
      headerClassName: 'primary--bg white--clr',
      editable: auth.accessLevel > 40,
      type: 'number',
      hide: !licensor.isDifferent
    },
    {
      field: 'qty40Plus',
      headerName: 'QTY 40+',
      flex: 1,
      headerClassName: 'primary--bg white--clr',
      editable: auth.accessLevel > 40,
      type: 'number',
      hide: !licensor.isDifferent
    }
  ];

  const connectionTypeFormik = useFormik({
    initialValues: connectionType,
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      id: Yup.number(),
      licensorId: Yup.number(),
      name: Yup.string().required().max(500),
    }),
    onSubmit: (values) => {
      setIsLoading(true);
      if (values.id === 0) {
        createConnectionType(values);
      } else {
        updateConnectionType(values);
      }
    },
  });

  const getLicensor = () => {
    setIsLoading(true);
    licensorService.getLicensorById(licensorId).then((res) => {
      setLicensor(res);
      if (tabKey === -1 && res.connectionTypes.length > 0) {
        setTabKey(res.connectionTypes[0].id);
      }
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const getConnectionType = (id) => {
    setIsLoading(true);
    connectionTypeService.getConnectionTypeById(id).then((res) => {
      setConnectionType(res);
      setIsConnectionTypeModalOpen(true);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const createConnectionType = (model) => {
    connectionTypeService.createConnectionType(model).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      getLicensor();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      handleConnectionTypeModalClose();
      setIsLoading(false);
    });
  };

  const updateConnectionType = (model) => {
    connectionTypeService.updateConnectionType(model).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      getLicensor();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      handleConnectionTypeModalClose();
      setIsLoading(false);
    });
  };

  const deleteConnectionType = (id) => {
    setIsLoading(true);
    hideConfirmModal();
    connectionTypeService.deleteConnectionType(id).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      getLicensor();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const deleteConnection = (id) => {
    setIsLoading(true);
    hideConfirmModal();
    connectionService.deleteConnection(id).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      fetchConnections();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const handleConnectionTypeModalClose = () => {
    setIsConnectionTypeModalOpen(false);
    setTimeout(() => {
      setConnectionType(initialConnectionTypeModel);
      connectionTypeFormik.resetForm();
    }, 250);
  };

  const fetchConnections = () => {
    setIsLoading(true);
    connectionService.getConnections(tabKey).then((res) => {
      setConnections(res);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const handleAfterEdit = (model) => {
    connectionService.updateConnection(model).then((res) => {
      console.log(res);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  return (
    <CustomBlock className="content-container--padded">
      {isLoading && <Overlay hasLoader />}
      <Section isFullWidth>
        <ContentBlock>
          <CustomBlock className="content-container--card-style--with-shadow">
            <ContentHeader
              title={licensor.name}
              headerSize="lg"
              primaryButtonText={auth.accessLevel > 40 ? 'New Connection Type' : ''}
              primaryButtonOnClick={() => setIsConnectionTypeModalOpen(true)}
            />

            <Section hasNoContainer>
              {
                licensor.connectionTypes.length > 0 ? (
                  <Tabs
                    id="tab"
                    className="mb-3"
                    activeKey={tabKey}
                    onSelect={(k) => setTabKey(k)}
                  >
                    {
                      licensor.connectionTypes.map((type) => (
                        <Tab
                          eventKey={type.id}
                          title={type.name}
                        >
                          <Section hasNoContainer className="mb-15">
                            <ContentBlock cols={2} className="pl-0">
                              <SelectBlock
                                value={sizeFilter}
                                label="Filter Sizes"
                                closeMenuOnSelect
                                placeholder="Please Select Size"
                                options={sizeOptions}
                                onChange={(opt) => {
                                  setSizeFilter(opt);
                                }}
                              />
                            </ContentBlock>

                            <ContentBlock cols={10}>
                              {
                                auth.accessLevel > 40 && (
                                  <CustomBlock className="flex--end mt-50">
                                    <Button
                                      text="Add"
                                      size="xs"
                                      className="primary--bg mr-5"
                                      onClick={() => setIsConnectionModalVisible(true)}
                                    />

                                    <Button
                                      text="Edit"
                                      size="xs"
                                      className="secondary--bg mr-5"
                                      onClick={() => getConnectionType(type.id)}
                                    />

                                    <Button
                                      text="Delete"
                                      size="xs"
                                      className="danger--bg"
                                      onClick={() => {
                                        showConfirmModal({
                                          title: 'Delete Connection Type',
                                          text: 'Are you sure you want to delete this connection type?',
                                          rightBtnText: 'Confirm',
                                          btnAction: () => {
                                            deleteConnectionType(type.id);
                                          }
                                        });
                                      }}
                                    />
                                  </CustomBlock>
                                )
                              }

                            </ContentBlock>
                          </Section>

                          <Box sx={{
                            height: '70vh',
                            width: '100%',
                          }}
                          >
                            <DataGrid
                              rows={filteredSource}
                              columns={columns}
                              rowsPerPageOptions={[5]}
                              pageSize={12}
                              ref={apiRef}
                              autoHeight
                              showCellRightBorder
                              showColumnRightBorder
                              disableSelectionOnClick
                              onCellEditCommit={({ id, field, value }) => {
                                const originalModel = connections.find((x) => x.id === id);
                                if (originalModel) {
                                  originalModel[field] = value;
                                  handleAfterEdit(originalModel);
                                }
                              }}
                            />
                          </Box>
                        </Tab>
                      ))
                    }
                  </Tabs>
                ) : <p>No connection Types available.</p>
              }
            </Section>
          </CustomBlock>
        </ContentBlock>
      </Section>

      <ModalBlock
        hasCloseAction
        centered
        isVisible={isConnectionTypeModalOpen}
        size="md"
        contentHeader={connectionType.id === 0 ? 'Add Connection Type' : 'Edit Connection Type'}
        primaryModalActionText={connectionType.id === 0 ? 'Create' : 'Save Changes'}
        primaryModalActionColor="primary--bg"
        primaryModalActionOnClick={connectionTypeFormik.handleSubmit}
        secondaryModalActionText="Cancel"
        secondaryModalActionColor="danger--bg"
        onHide={handleConnectionTypeModalClose}
      >
        <FormBlock onSubmit={connectionTypeFormik.handleSubmit}>
          <Section hasNoContainer>
            <ContentBlock>
              <InputBlock
                label="Name"
                isRequired
                errorMessage={connectionTypeFormik.errors.name}
                inputState={`${helper.getInputClasses(connectionTypeFormik, 'name')}`}
                {...connectionTypeFormik.getFieldProps('name')}
              />
            </ContentBlock>
          </Section>
        </FormBlock>
      </ModalBlock>

      {
        (licensor.connectionTypes.length > 0 && tabKey > -1) && (
          <ConnectionCreateForm
            licensor={licensor}
            showAlert={showAlert}
            setIsLoading={setIsLoading}
            fetchConnections={fetchConnections}
            isConnectionModalVisible={isConnectionModalVisible}
            setIsConnectionModalVisible={setIsConnectionModalVisible}
            connectionTypeId={tabKey}
            connectionType={activeConnectionTypeName}
          />
        )
      }

    </CustomBlock>
  );
};

const mapStateFromProps = (state) => ({ auth: state.auth });

export default connect(
  mapStateFromProps,
  {
    ...alert.actions,
    ...confirmModal.actions
  }
)(LicensorManagementPage);